// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 9V3H1V9L23 9Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 11V21L1 21V11H13V16.4971L15.5 14.3338L18 16.4971V11H23Z"}}]};

const CardmembershipFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'cardmembership-filled',
    ref,
    icon: element,
  },
));

CardmembershipFilledIcon.displayName = 'CardmembershipFilledIcon';

export default CardmembershipFilledIcon;
